<template>
  <div>
    <AllCases :selectedStatuses="statuses" :issues="true" />
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllCases = defineAsyncComponent(() =>
  import("@/components/cases/AllCases")
);
export default {
  name: "RequiresAttentionCases",
  components: { AllCases },
  data() {
    return { statuses: ["ACTIVE", "TEST_REPORTS", "COMPLETE"] };
  },
};
</script>
